export const CountiesWithParcelData = [
  'Aiken',
  'Allendale',
  'Beaufort',
  'Berkeley',
  'Calhoun',
  'Charleston',
  'Cherokee',
  'Chester',
  'Chesterfield',
  'Clarendon',
  'Colleton',
  'Darlington',
  'Dillon',
  'Dorchester',
  'Edgefield',
  'Fairfield',
  'Greenville',
  'Greenwood',
  'Hampton',
  'Horry',
  'Jasper',
  'Kershaw',
  'Laurens',
  'Lee',
  'Lexington',
  'Marion',
  'Marlboro',
  'McCormick',
  'Newberry',
  'Oconee',
  'Pickens',
  'Richland',
  'Saluda',
  'Spartanburg',
  'Sumter',
  'Union',
  'York',
];
